// Mise en page horizontale : dès que la fenêtre est au moins aussi large que haute (carrée ou plus large : téléphone en paysage,
// fenêtre d'ordinateur), l'appli passe sur un seul bandeau en haut (logo, niveau, pellicule qu'on fait glisser, boutons galerie /
// musique / volume, pièces, partage, profil), fixe et sans rien en dessous : le cadre de photographie prend tout le reste de
// l'écran, sans que le bandeau ne le recouvre. L'attribut `data-layout` de <html> vaut « landscape » ou « portrait » (voir
// main.css). `?layout=landscape` (ou `portrait`) dans l'adresse force un mode.

/** Fenêtre carrée ou plus large que haute. */
export const LANDSCAPE_QUERY = '(min-aspect-ratio: 1/1)';

/**
 * @param {{ landscape: boolean, forced?: string|null }} options
 * @returns {'landscape'|'portrait'}
 */
export function layoutModeFor({ landscape, forced = null }) {
  if (forced === 'landscape' || forced === 'portrait') return forced;
  return landscape ? 'landscape' : 'portrait';
}

/** Pose `data-layout` sur <html> et la tient à jour à chaque rotation ou redimensionnement de la fenêtre. */
export function watchLayoutMode(win = window, root = document.documentElement) {
  const forced = new URLSearchParams(win.location?.search ?? '').get('layout');
  const query = win.matchMedia?.(LANDSCAPE_QUERY);
  const apply = () => root.setAttribute('data-layout', layoutModeFor({ landscape: !!query?.matches, forced }));
  apply();
  query?.addEventListener?.('change', apply);
  return { apply, destroy: () => query?.removeEventListener?.('change', apply) };
}
